import React from "react";
import { FaPhoneAlt, FaWhatsapp, FaMapMarkerAlt } from "react-icons/fa";

export default function ContactCards({ title, number,mapiframe }) {
  return (
    <section className="contact-section">
      <h2>Contact Us</h2>

      <div className="contact-grid">
        {/* Call Card */}
        <div className="contact-card">
          <div className="contact-icon blue">
            <FaPhoneAlt />
          </div>
          <div>
            <p className="contact-title">Call Us</p>
            <a href="tel:9031062015">+91 9031062015</a>
            <span>{title}, Jharkhand, India</span>
          </div>
        </div>

        {/* WhatsApp Card */}
        <div className="contact-card">
          <div className="contact-icon green">
            <FaWhatsapp />
          </div>
          <div>
            <p className="contact-title">WhatsApp</p>
            <a href="https://wa.me/919031062015" target="_blank" rel="noreferrer">
              +91 9031062015
            </a>
            <span>{title}, Jharkhand, India</span>
          </div>
        </div>

        {/* Location Card */}
        {/* Location Card */}
        <div className="contact-card map-card">
          <iframe
            title="{title} Location Map"
            src={mapiframe}
            width="100%"
            height="300"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
          ></iframe>

          <a
            href="https://www.google.com/maps?q=Hazaribag,Jharkhand,India"
            target="_blank"
            rel="noreferrer"
            className="direction-btn"
          >
            Get Directions
          </a>
        </div>
      </div>
    </section>
  );
}
